module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 11\"><path fill=\"#A2B0D5\" fill-rule=\"nonzero\" d=\"M10.8 2.75L9.56 4 7 1.44 8.25.2c.26-.27.7-.27.96 0l1.6 1.6c.26.25.26.7 0 .95zM6.73 2L9 4.27 2.29 11H0V8.72L6.73 2z\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./public/img/pen.svg
// module id = Q68q
// module chunks = 5